// Marketing content shared constants. Mirrors waggle-api's src/constants/marketing.js — keep the
// values in sync across the two repos, since they are the API contract.

export const EVENT = 'event'
export const BAR_ITEM = 'bar_item'
export const PARTNERSHIP = 'partnership'

export const MARKETING_CONTENT_CATEGORIES = [EVENT, BAR_ITEM, PARTNERSHIP]

export const MARKETING_CONTENT_STATUS = {
	DRAFT: 'draft',
	ACTIVE: 'active',
	INACTIVE: 'inactive',
	DELETED: 'deleted'
}

// Redux action types. No reducer handles these today (writes patch local state), but they are
// named here so the dispatches stay consistent and typo-proof.
export const MARKETING_CONTENT_ACTIONS = {
	SAVING: 'MARKETING_CONTENT_SAVING',
	SAVED: 'MARKETING_CONTENT_SAVED',
	FAIL: 'MARKETING_CONTENT_FAIL',
	DELETED: 'MARKETING_CONTENT_DELETED',
	REORDERED: 'MARKETING_CONTENT_REORDERED'
}
